import { type AnyAction, type Reducer, combineReducers } from 'redux';
import JourneyLegacyReducer from '../../../main/reducers/JourneyReducer';
import type { JourneyReducer as JourneyLegacyReducerType } from '../../../main/types/journeyTypes';
import JourneysHistoryReducer from './JourneysHistory/JourneysHistory.reducer';
import type { ReducerState as JourneysHistoryReducerType } from './JourneysHistory/types';

interface JourneysReducerType {
  journeysLegacy: JourneyLegacyReducerType;
  journeysHistory: JourneysHistoryReducerType;
}

const ARR_JOURNEY_REDUCERS = [
  { key: 'journeysLegacy', reducer: JourneyLegacyReducer },
  { key: 'journeysHistory', reducer: JourneysHistoryReducer },
];

const JourneysReducer = (() => {
  const reducers = ARR_JOURNEY_REDUCERS.reduce((acc, { key, reducer }) => {
    acc[key] = reducer;
    return acc;
  }, {});
  return combineReducers(reducers);
})();

export default JourneysReducer as Reducer<JourneysReducerType, AnyAction>;
